import { Crudable } from "kinnect-mixins";
import {
	KActionDialog,
	KDataTable,
	KDataTableMenu,
	KValidatableInput
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default KDataTable.extend( {
	name: "KPurchaseOrdersTable",

	mixins: [
		Crudable,
		KValidatableInput
	],

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no purchase orders to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching purchase orders found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "purchaseOrderNumber"
		},

		value: {
			type: Array,
			default: () => []
		}
	},

	data: () => ( {
		crud: "purchase_orders"
	} ),

	computed: {
		defaultHeaders() {
			return [
				{
					text: "PO #",
					value: "purchaseOrderNumber"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		deletePurchaseOrder( purchaseOrder ) {
			const deleteIndex = this.items.findIndex( item => purchaseOrder.id === item.id );

			return purchaseOrder.delete().then( () => {
				this.$delete( this.items, deleteIndex );
			} );
		},

		genValidatableField( props ) {
			return <KDataTable
				attrs={this.$props}
				hasErrors={Boolean( props.errors.length )}
				headers={this.$_headers}
				on={{ ...this.$listeners }}
				scopedSlots={{
					"header.data-table-select": () => "Select",

					"item.actions": ( { item } ) =>
						<KDataTableMenu>
							<VList>
								<VListItem to={{
									name: "salesPurchaseOrder",
									params: { idPurchaseOrder: item.id }
								}}>
									<VListItemAction>
										<VIcon>visibility</VIcon>
									</VListItemAction>

									<VListItemContent>
										<VListItemTitle>View</VListItemTitle>
									</VListItemContent>
								</VListItem>

								{this.canDelete && <KActionDialog
									confirmButtonColor="error"
									confirmButtonText="Delete"
									loading={this.$wait.is( "delete purchase order" )}
									onConfirm={() => this.deletePurchaseOrder( item )}
									scopedSlots={{
										activator: ( { on } ) =>
											<VListItem on={on}>
												<VListItemAction>
													<VIcon>delete</VIcon>
												</VListItemAction>

												<VListItemContent>
													<VListItemTitle>Delete</VListItemTitle>
												</VListItemContent>
											</VListItem>
									}}
									title="Delete Purchase Order"
								>
									Are you sure you want to delete the purchase order <strong>{item.purchaseOrderNumber}</strong>?
								</KActionDialog>}
							</VList>
						</KDataTableMenu>,

					...this.$scopedSlots
				}}
				vModel={this.internalValue}
			></KDataTable>;
		}
	},

	render() {
		if ( this.showSelect ) {
			this.genValidationProvider();
		}

		return this.genValidatableField( { errors: [] } );
	}
} );
